import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { CourseAssignee } from './getCourseAssignees';

export type CourseTeamAssignee = {
   teamid: number;
   avatar: string;
   team_name: string;
   time_allotted: number | null;
   team_assignment_date: number | null;
   members_count: number;
   members_completed: number;
   members: CourseAssignee[];
};

export type CourseTeamAssigneesOptions = {
   page?: number;
   limit?: number;
   search?: string;
};

export type CourseTeamAssigneesResponse = {
   response: Array<CourseTeamAssignee>;
   hasMore: boolean;
   totalAssignees: number;
};

export async function getCourseTeamAssignees(
   wikiid: number,
   options?: CourseTeamAssigneesOptions,
   common: CommonRequestOptions = {}
): Promise<CourseTeamAssigneesResponse> {
   const { page = 1, limit = 10 } = options ?? {};

   let queryParams = `page=${page}&limit=${limit}`;
   queryParams += options?.search ? `&search=${options.search}` : '';

   return await makeRequest('get', `course_assignees/course/${wikiid}/teams?${queryParams}`, {
      ...common,
   });
}
